import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import DiscussionCreateMain from './DiscussionCreateMain'
import actions from '../../../store/actions'

const mapStateToProps = state => ({
  events: state.events,
  topics: state.topics,
  isFetching: state.organizations.isFetching,
  list: state.organizations.list.rows,
  library: state.library,
  user: state.user,
  organizations: state.organizations.list
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      upload: (file, opts) => dispatch(actions.library.upload(file, opts)),
      clearUploadList: actions.library.clearUploadList,
      updateUser: actions.user.updateUser,
      updateTopicList: actions.topics.updateTopicList,
      get: actions.organizations.get
    },
    dispatch
  )

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DiscussionCreateMain)
